import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
import { useSnackbar } from '@components/Provider';
import {
  CapaErrorCode,
  useFetchMyQuotationUserLazyQuery
} from '@generated/graphql';
import useClient from '@hooks/useClient';
import { authStorageClear } from '@utils/storage';

const AccountSwitchContainer: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [
    fetchMyQuotationUser,
    fetchMyQuotationUserQuery
  ] = useFetchMyQuotationUserLazyQuery({
    fetchPolicy: 'network-only'
  });
  const { onGetClient, onUpdateToken, onInitClient } = useClient();
  const { accessToken, refreshToken, signUp } = queryString.parse(
    location.search
  );

  useEffect(() => {
    onInitClient();
    authStorageClear();
    localStorage.clear();
  }, [onInitClient]);

  useEffect(() => {
    if (accessToken && refreshToken) {
      onUpdateToken({
        accessToken: accessToken as string,
        refreshToken: refreshToken as string
      });

      fetchMyQuotationUser();
    } else {
      history.push('/');
    }
  }, [
    accessToken,
    refreshToken,
    fetchMyQuotationUser,
    history,
    enqueueSnackbar,
    onUpdateToken
  ]);

  useEffect(() => {
    if (fetchMyQuotationUserQuery.error) {
      history.push('/dashboard', {
        isRegistComplete: signUp === 'true'
      });
    }

    if (fetchMyQuotationUserQuery.data) {
      const { data: clientInfo } = fetchMyQuotationUserQuery;
      const success =
        clientInfo?.fetchMyQuotationUser.result === CapaErrorCode.Success;
      if (success && clientInfo?.fetchMyQuotationUser.data) {
        onGetClient({ ...clientInfo?.fetchMyQuotationUser.data });
      }

      history.push('/dashboard', {
        isRegistComplete: signUp === 'true' ? true : false
      });
    }
  }, [signUp, fetchMyQuotationUserQuery, history, onGetClient]);

  return <></>;
};

export default AccountSwitchContainer;
